function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#222b45;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "upload-cloud",
  transform: "translate(.514 -1.495)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9549",
  "data-name": "Path 9549",
  className: "cls-1",
  d: "M25.222 20.611 16.611 12 8 20.611",
  transform: "translate(8.075 10.372)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_556",
  "data-name": "Line 556",
  className: "cls-1",
  transform: "translate(24.997 22.748)",
  d: "M0 0v19"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9550",
  "data-name": "Path 9550",
  className: "cls-1",
  d: "M42.747 36.127A10.763 10.763 0 0 0 37.6 15.914h-2.71A17.222 17.222 0 1 0 5.312 31.628"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9551",
  "data-name": "Path 9551",
  className: "cls-1",
  d: "M25.222 20.611 16.611 12 8 20.611",
  transform: "translate(8.075 10.372)"
}));

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.389,
    height: 41.753,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.ce237de1.svg";
export { ForwardRef as ReactComponent };